import React, { useCallback, useState } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { createSelector } from "reselect";
import {
  TableContainer,
  Table,
  Thead,
  TheadRow,
  TableHeader,
  TableHeaderIcon,
  TableBody,
  LoadingRow,
  IconContainer,
  TD,
  style,
} from "./styles";
import dayjs from "dayjs";
import { css } from "@emotion/core";
import { makeStyles } from "@material-ui/core/styles";

// extra componets
import MenuTableRow from "components/MenuTableRow/MenuTableRow";
import HashLoader from "react-spinners/HashLoader";

// icons
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";

// actions creators

import {
  getUnitDocuments,
  toggleIsDownward,
  SET_SELECTED_UNITS,
  REMOVE_SELECTED_UNIT,
  SET_TABLE_DETAILS,
  REMOVE_TABLE_DETAILS,
} from "redux/ducks/mapPage";

// Selectors
const unitsFiltered = createSelector(
  (state) => state.map.units,
  (state) => state.map.search,
  (state) => state.map.typesValues,
  (units, search, typesValues) => {
    if (typesValues.length) {
      return units
        .filter((item) =>
          item.number.toLowerCase().includes(search.toLowerCase())
        )
        .filter((item) => typesValues.includes(item.type));
    }
    return units.filter((item) =>
      item.number.toLowerCase().includes(search.toLowerCase())
    );
  }
);

const useStyles = makeStyles(style);
const override = css`
  display: block;
  margin: 2rem auto;
`;

const MenuTable = ({ color }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [date] = useState(dayjs().format("YYYY-MM-DD"));
  const addSelectedUnit = useCallback(
    (id) => dispatch({ type: SET_SELECTED_UNITS, payload: id }),
    [dispatch]
  );
  const removeSelectedUnit = useCallback(
    (id) => dispatch({ type: REMOVE_SELECTED_UNIT, payload: id }),
    [dispatch]
  );
  const addTableDetail = useCallback(
    (number, id) => {
      dispatch({ type: SET_TABLE_DETAILS, payload: number });
      dispatch(getUnitDocuments(id, date));
    },
    [dispatch, date]
  );
  const removeTableDetail = useCallback(
    (id) => dispatch({ type: REMOVE_TABLE_DETAILS, payload: id }),
    [dispatch]
  );
  const handleSort = useCallback(() => {
    dispatch(toggleIsDownward());
  }, []);
  const units = useSelector(unitsFiltered);
  const selectedUnits = useSelector(
    (state) => state.map.selectedUnits,
    shallowEqual
  );
  const tableDetails = useSelector(
    (state) => state.map.tableDetails,
    shallowEqual
  );
  const isLoadingUnits = useSelector(
    (state) => state.map.isLoadingUnits,
    shallowEqual
  );
  const isDownward = useSelector((state) => state.map.isDownward, shallowEqual);

  const isRowSelected = (number) => {
    return selectedUnits.includes(number) || tableDetails.includes(number)
      ? "active-row"
      : "";
  };

  const isOpen = (number) => {
    return tableDetails.includes(number);
  };

  return (
    <TableContainer>
      <Table>
        <Thead>
          <TheadRow color={color}>
            <TableHeaderIcon>
              Unidad
              <IconContainer onClick={() => handleSort()}>
                {isDownward ? (
                  <ArrowDownwardIcon className={classes.fontSizeInherit} />
                ) : (
                  <ArrowUpwardIcon className={classes.fontSizeInherit} />
                )}
              </IconContainer>
            </TableHeaderIcon>
            <TableHeader>Conexión</TableHeader>
            <TableHeader width={20}>Pedidos</TableHeader>
            <TableHeader>Capacidad</TableHeader>
          </TheadRow>
        </Thead>

        <TableBody>
          {units.map((item, index) => {
            return (
              <MenuTableRow
                key={`${item.number}-${index}`}
                index={index}
                item={item}
                color={color}
                isOpen={isOpen(item.number)}
                isRowSelected={isRowSelected(item.number)}
                isLoading={item.isLoading}
                onSelectRow={
                  !selectedUnits.includes(item.number)
                    ? addSelectedUnit
                    : removeSelectedUnit
                }
                onClickDetail={
                  !tableDetails.includes(item.number)
                    ? addTableDetail
                    : removeTableDetail
                }
              />
            );
          })}
          <LoadingRow className="sweet-loading">
            <TD>
              <HashLoader
                css={override}
                size={45}
                color={`${color}`}
                loading={isLoadingUnits}
              />
            </TD>
          </LoadingRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default React.memo(MenuTable);
